import { Link, useLocation } from "react-router";
import { useAuth } from "../../hooks/use-auth";
import { useFollowState } from "../../hooks/use-follow-state";
import { authFetch } from "../../lib/auth-fetch";

interface FollowButtonProps {
	authorId: string;
}

const FollowButton = ({ authorId }: FollowButtonProps) => {
	const location = useLocation();
	const authState = useAuth();
	const { isFollowing, uid } = useFollowState(authorId);

	// Don't show while auth is loading or if viewing own profile
	if (authState === "loading") return null;
	if (uid === authorId) return null;

	if (authState === "unauthenticated") {
		const next = encodeURIComponent(location.pathname);
		return (
			<Link to={`/register?next=${next}`}>Follow</Link>
		);
	}

	const handleToggle = () => {
		authFetch(`/api/users/${authorId}/follow`, {
			method: isFollowing ? "DELETE" : "POST",
		}).catch(console.error);
	};

	return (
		<button type="button" onClick={handleToggle}>
			{isFollowing ? "Unfollow" : "Follow"}
		</button>
	);
};

export default FollowButton;
